export function extractFieldGateway(rawFieldGateway: $TSFixMe) {
  const fieldGateway = {
    id: rawFieldGateway.id,
    ipAddress: rawFieldGateway.ip_address,
    name: rawFieldGateway.name,
    description: rawFieldGateway.description,
    status: rawFieldGateway.status,
    type: rawFieldGateway.type,
  };
  if (
    rawFieldGateway.specifications &&
    rawFieldGateway.specifications["eh.edm.hart.address"]
  ) {
    (fieldGateway as $TSFixMe).hartAddress =
      rawFieldGateway.specifications["eh.edm.hart.address"].value;
  }
  if (rawFieldGateway.port) {
    (fieldGateway as $TSFixMe).port = rawFieldGateway.port;
  }
  return fieldGateway;
}

export function extractFieldGateways(rawFieldGatways: $TSFixMe) {
  return rawFieldGatways.field_gateways.map((fieldGateway: $TSFixMe) =>
    extractFieldGateway(fieldGateway),
  );
}
